import SpriteSymbol from "../../../../node_modules/svg-baker-runtime/browser-symbol.js";
import sprite from "../../../../node_modules/svg-sprite-loader/runtime/browser-sprite.build.js";
var symbol = new SpriteSymbol({
  "id": "Blue_Arrow_R",
  "use": "Blue_Arrow_R-usage",
  "viewBox": "0 0 22.5 42",
  "content": "<symbol xmlns=\"http://www.w3.org/2000/svg\" viewBox=\"0 0 22.5 42\" id=\"Blue_Arrow_R\">\n  <path id=\"Blue_Arrow_R_Union_2\" data-name=\"Union 2\" d=\"M0,17.559,17.5,37ZM17.5,0,0,17.559Z\" transform=\"translate(20 39.5) rotate(180)\" fill=\"none\" stroke=\"#007aa4\" stroke-linecap=\"round\" stroke-linejoin=\"round\" stroke-width=\"5\" />\n</symbol>"
});
var result = sprite.add(symbol);
export default symbol